export const senderEmailNotFoundLabel = "irbcQd";
export default {senderEmailNotFoundLabel};